import React from "react"

import { Text } from "lucide-react"

import type { ChartVisualizationProps } from "../types/chart"
import {
  AGGREGATION_TYPE,
  DATA_SOURCE,
  VISUALIZATION_TYPE,
} from "../types/core"
import { BaseWidget, type WidgetProps } from "./BaseWidget"
import { TextVisualization } from "./chart/visualizations/TextVisualization"

export class TextWidget extends BaseWidget {
  type = "text"
  title = "Text"
  description = "Display static text content"
  icon = (<Text className="w-5 h-5" />)
  disabled = false

  renderWidget(props: WidgetProps): React.ReactNode {
    const config = props.widget.config || this.getDefaultConfig()

    return (
      <TextVisualization
        chartData={[]}
        config={config as ChartVisualizationProps["config"]}
        splitKeys={[]}
        colors={[]}
        displayNameLookups={null}
      />
    )
  }

  getDefaultConfig() {
    return {
      title: this.title,
      description: "",
      text: "",
      visualizationType: VISUALIZATION_TYPE.TEXT,
      dataSource: DATA_SOURCE.SIMULATED,
      aggregation: AGGREGATION_TYPE.AVG,
      metricOutputType: "float" as const,
    }
  }
}
